import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  
  fetchPlanPrice,
  fetchPlanPriceById,
} from "./PriceSectionAPI";

const initialState = {
  planPrice: [],
  status: "idle",

  SelectedPlan: null,
};

export const fetchPlanPriceAsync = createAsyncThunk(
  "plan/fetchPlanPrice",
  async () => {
    const response = await fetchPlanPrice();
    return response.data;
  }
);

export const fetchPlanPriceByIdAsync = createAsyncThunk(
  "plan/fetchPlanPriceById",
  async (id) => {
    const response = await fetchPlanPriceById(id);
    return response.data;
  }
);



export const PriceSectionSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlanPriceByIdAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPlanPriceByIdAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.SelectedPlan = action.payload;
      })
      .addCase(fetchPlanPriceAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPlanPriceAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.planPrice = action.payload;
      })

  },
});

export const SelectPlanPrice = (state) => state.plan.planPrice;

export const SelectPlanById = (state) => state.plan.SelectedPlan;

export default PriceSectionSlice.reducer;
